export default __webpack_public_path__ + "static/media/IMG-20220428-WA0021.10868273.jpg";